'use strict';

var react = require('@emotion/react');

const topAlignment = /*#__PURE__*/ react.css({
    alignItems: "baseline"
}, "label:label-Radio-web-stylestopAlignment", "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2J1aWxkcy9kZXZlbG9wZXJzL2F2aWFyeS9wYWNrYWdlcy9hdmlhcnktd2ViL3NyYy9jb21wb25lbnRzL2F0b21zL1JhZGlvL1JhZGlvLndlYi5zdHlsZXMudHMiLCJzb3VyY2VzIjpbIi9idWlsZHMvZGV2ZWxvcGVycy9hdmlhcnkvcGFja2FnZXMvYXZpYXJ5LXdlYi9zcmMvY29tcG9uZW50cy9hdG9tcy9SYWRpby9SYWRpby53ZWIuc3R5bGVzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcyB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdFwiO1xuXG5leHBvcnQgY29uc3QgdG9wQWxpZ25tZW50ID0gY3NzKHtcbiAgYWxpZ25JdGVtczogXCJiYXNlbGluZVwiLFxufSk7XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRTRCIn0= */");

exports.topAlignment = topAlignment;
//# sourceMappingURL=Radio.web.styles.cjs.map
